import Router from './Router.container';

export default Router;
